import { useState, useEffect, useCallback } from 'react';
import brandDnaActions from '../../../../actions/brandDna';

const useBrandDetail = (brandId) => {
  const [brand, setBrand] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Silent refresh: keeps current brand visible, no skeleton flash
  const refresh = useCallback(async () => {
    try {
      const res = await brandDnaActions.getBrand(brandId);
      if (res.success) setBrand(res.data);
    } catch {
      // silent — don't disturb UI on background refresh failure
    }
  }, [brandId]);

  // Initial load only
  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    setError(null);
    brandDnaActions.getBrand(brandId)
      .then((res) => {
        if (cancelled) return;
        if (res.success) setBrand(res.data);
        else setError('Failed to load brand');
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err?.response?.data?.error ?? 'Failed to load brand');
      })
      .finally(() => { if (!cancelled) setIsLoading(false); });
    return () => { cancelled = true; };
  }, [brandId]);

  return { brand, isLoading, error, refresh };
};

export default useBrandDetail;
